
const ratingList = ["#75BCE0", "#8BBC01", "#CCB300", "#FF9357", "#e86e5e", "#6b6b6bfa",]

const ratingColors = ["#75BCE0", "#8BBC01", "#CCB300", "#FF9357", "#e86e5e", "#6b6b6bfa",]
const ratingColors2 = ["#CBE7F9", "#DBF4C1", "#F8F1C1", "#F8D2C1", "#F6C2BF",]
const ratingColors3 = ["#FFD6D4", "#FEE4D8", "#FEFAD8", "#EBFED8", "#D8EFFE", "#6b6b6bfa",]
const ratingColors4 = ["#91D4FA", "#99C320", "#EEC808", "#FB7401", "#FF0000"]
const ratingColors5 = ["#1577FF", "#85A81F", "#AB9603", "#FB7401", "#FF2618"]
const ratingColors6 = ["#CBE1FF", "#E4F2D1", "#F4F1BD", "#FEE4D8", "#FBD9DA"]
const ratingColors7 = ["#CCE1FF", "#E9F6D4", "#FFF6CC", "#FEE4D8", "#FBD9DA"]
const ratingColors8 = ["#ADCFFF", "#DCF0B8", "#FFEF99", "#FFC7A3", "#F99"]
const ratingTexts8 = ["#2C84FF", "#7FAE1A", "#B89C00", "#FB7401", "#FF4D4D",]

const ratingText = ["#4D9BC8", "#779A11", "#AB9603", "#E06700", "#C70404",]
const ratingTexts2 = ["#2C84FF", "#7FAE1A", "#B89C00", "#E06700", "#C70404",]

const dashbordLabelsColors = ["#FFE5E5","#FFE6D6", "#FFF6CC","#E9F6D4", "#CCE1FF"]
const dashbordBackgroundColors = ["#FFF5F5","#FFFAF6", "#FFFEF5","#E9F6D4", "#CCE1FF"]

const ratingBgColors = ["#add6ef", "#b8d67f", "#d9d17f", "#f3c1aa", "#e7afae", "#6b6b6bfa",]
const ratingBgColors2 = ["", "#CBE1FF", "#E4F2D1", "#F4F1BD", "#FEE4D8", "#FBD9DA",]
const ratingListTheme = ["rating1", "primary", "rating3", "rating4", "rating5"]
const ratingListLabel = ["גבוה", "בטווח המצופה", "מעט נמוך", "נמוך", "נמוך מאד"]
const ratingListLabel2 = ["גבוהה", "מותאמת", "מעט נמוכה", "נמוכה", "נמוכה מאד"]
const ratingListLabel3 = ["ברצף", "ברצף", "מעט מקוטע", "מקוטע", "מקוטע מאד"]
const ratingListLabel4 = ["גבוה", "מצוין", "סביר", "נמוך", "נמוך מאד"]
const ratingListLabel5 = ["מהירה", "בקצב המצופה", "מעט איטית", "איטית", "איטית מאד"]
const ratingListLabel6 = ["רציפה", "רציפה", "מעט מקוטעת", "מקוטעת", "מקוטעת מאד"]
const ratingListLabel7 = ["מהיר", "טוב", "קצת איטי", "איטי", "איטי מאד"]
const ratingListLabel8 = ["מדויקת מאד", "מדויקת", "לא מספיק מדויקת", "לא מדויקת", "מאוד לא מדויקת"]
const ratingListLabel9 = ["גבוה", "בטווח המצופה", "מעט נמוך", "נמוך", "נמוך מאד"]
const ratingListLabel10 = ["גבוה", "מצופה", "מעט נמוך", "נמוך", "נמוך מאד"]

const ratingIcons = ["fa-regular fa-face-grin-stars", "fa-regular fa-face-smile", "fa-regular fa-face-meh", "fa-regular fa-face-frown", "fa-regular fa-face-dizzy"]

const prosodyLabels = ["מתאימה", "בינונית", "לא מתאימה",]
const ratingListChipColors = ["thirdly", "green", "yellow", "secondary", "error"]

const ratingFrequency = ["98-101%", "94-98%", "89-94%", "80-89%", "1-80%",]
const frequencyRagtingWithLabels = [
    `${ratingListLabel2[0]} ${ratingFrequency[0]}`,
    `${ratingListLabel2[1]} ${ratingFrequency[1]}`,
    `${ratingListLabel2[2]} ${ratingFrequency[2]}`,
    `${ratingListLabel2[3]} ${ratingFrequency[3]}`,
    `${ratingListLabel2[4]} ${ratingFrequency[4]}`,
]

const naLabel = "ל/ת"
const deviationRatingIndex = 2

const ratingKeys = {
    "words_per_minute": "קצב",
    "factored_percent_accuracy": "דיוק (משוקלל)",
    "percent_accuracy": "דיוק (גוֺלְמִי)",
    "fluency_reading": "רציפות קריאה",
    "self_correction": "תיקון עצמי",
    "minor_error": "שגיאה קלה",
    "correct_words_per_minute": "מספר מילים נכונות לדקה",
    "prosody": "פרוזודיה"
}

export { ratingIcons, dashbordLabelsColors, ratingTexts2, ratingColors7, ratingBgColors2, ratingListLabel7, ratingListLabel8, ratingListChipColors, prosodyLabels, ratingKeys, ratingColors6, ratingColors5, ratingListLabel6, ratingListLabel5, ratingListLabel2, ratingListLabel4, ratingColors4, ratingColors, ratingListLabel3, ratingColors2, ratingColors3, naLabel, ratingText, ratingFrequency, frequencyRagtingWithLabels, deviationRatingIndex, ratingListTheme, ratingListLabel, ratingBgColors, ratingColors8, ratingListLabel9, ratingTexts8, ratingListLabel10, dashbordBackgroundColors }

export default ratingList